import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NewBankRequestService} from '@common/services/new-bank-request.service';
import {NotificationService} from '@shared/notifications/notification.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {DialogHeaderComponent} from '@reusable/dialog-header/dialog-header.component';
import {TranslateModule} from '@ngx-translate/core';
import {NgClass, NgIf} from '@angular/common';
import {ButtonComponent} from '../controls/button/button.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {LocalStorageService} from '@services/local-storage.service';
import {LsDatePipe} from '@common/time/ls-date.pipe';
import {BankRequestStatusBadgeComponent} from './bank-request-status-badge.component';
import {IBankRequest} from './bank-request.interface';

@Component({
  selector: 'app-new-bank-request',
  templateUrl: './new-bank-request.html',
  styleUrls: ['./new-bank-request.scss'],
    standalone: true,
  imports: [
    DialogHeaderComponent,
    ReactiveFormsModule,
    TranslateModule,
    NgClass,
    NgIf,
    ButtonComponent,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    LsDatePipe,
    BankRequestStatusBadgeComponent,
  ],
})
export class NewBankRequestComponent implements OnInit {
  form: FormGroup;
  loading: boolean;
  view: 'list' | 'form' = 'list';
  requests: IBankRequest[] = [];
  requestsLoading = false;

  constructor(
    private fb: FormBuilder,
    private notification: NotificationService,
    private service: NewBankRequestService,
    private bsModalService: BsModalService,
    private localStorageService: LocalStorageService,
  ) {
    this.initForm();
  }

  ngOnInit() {
    this.loadRequests();
  }

  loadRequests() {
    this.requestsLoading = true;
    this.service.list()
    .subscribe({
      next: (requests) => {
        this.requests = requests;
        this.requestsLoading = false;
      },
      error: (error) => {
        this.requestsLoading = false;
        this.notification.error(error);
      },
    });
  }

  showForm() {
    this.view = 'form';
  }

  showList() {
    this.view = 'list';
  }

  initForm() {
    this.form = this.fb.group({
      userFullName: [this.localStorageService.getCurrentUserDetails().fullName, Validators.required],
      firmName: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      email: ['', Validators.required],
      bankName: ['', Validators.required],
      bankUrl: ['', Validators.required],
      bankLoginUrl: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required],
      notes: ['', Validators.required],
      clientName: ['', Validators.required],
      extractChecks: [''],
      extractStatements: [''],
      extractTransactions: [''],
    });
  }

  onConfirmNewBankRequest() {
    this.loading = true;
    this.service.create(this.form.value)
    .subscribe({
      next: () => {
        this.loading = false;
        this.notification.success('New bank request has been successfully sent');
        this.initForm();
        this.view = 'list';
        this.loadRequests();
      },
      error: (error) => {
        this.loading = false;
        this.notification.error(error);
      },
    });
  }

  close() {
    this.bsModalService.hide();
  }
}
